var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsApp = function SvgWhatsApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#whats-app_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.507C6.284 1.51 1.508 6.292 1.508 12.004c0 2.06.613 4.094 1.757 5.814L1.504 22.5l5.894-1.066a10.5 10.5 0 0 0 4.603 1.058c5.722.004 10.503-4.773 10.503-10.489 0-5.71-4.783-10.5-10.503-10.497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.578 16.627c1.42.912 2.9.248 3.932-.521.712-.532.688-1.556.08-2.204l-1.2-1.277c-.454.455-1.34.68-1.957.493-1.324-.403-1.88-1.093-2.33-1.795-.518-.806.066-2.009.521-2.464l-1.337-1.22c-.563-.515-1.42-.602-1.911-.018-.973 1.154-1.578 2.907-.862 4.024 1.287 2.004 3.06 3.696 5.064 4.982"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "whats-app_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgWhatsApp;